export const FILTER_ASSIGN_TO_ME = 'FILTER_ASSIGN_TO_ME';
export const FILTER_STATUS = 'FILTER_STATUS';
export const FILTER_TAGS = 'FILTER_TAGS';
export const CHANGE_FULL_VIEW_MODE = 'CHANGE_FULL_VIEW_MODE';
export const UPDATE_LOADING_EXPORT = 'UPDATE_LOADING_EXPORT';
